import { z } from "zod";
import { COLORS } from "../../colors";

/**
 * @deprecated Use `tableTypeSchema` instead.
 */
export const ticketTypeSchema = z.object({
	color: z.enum(COLORS),
	icon: z.string(),
	id: z.string(),
	name: z.string().min(1).max(20),
	ranking: z.number(),
	state: z.enum(["active", "inactive"]),
	workspaceId: z.string().nullable(),
});
